import React, { Component } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

const { MonthPicker } = DatePicker;
const monthFormat = 'YYYY-MM';

class DateRange extends Component {
    state = {
        beginOpen: false,
        endOpen: false,
    }

    disabledStartDate = (date) => {
        const { value = [] } = this.props;
        const [begin, end] = value;
        return date.valueOf() > moment(end).valueOf();
    }

    disabledEndDate = (date) => {
        const { value = [] } = this.props;
        const [begin, end] = value;
        return date.valueOf() < moment(begin).valueOf();
    }

    handleChange = (date, dateString, type) => {
        const { value = [], disabledDate } = this.props;
        const [num, unit] = disabledDate || [];
        const [begin, end] = value;
        if (type === 'begin') {
            value[0] = dateString;
            if (disabledDate && end && moment(dateString).valueOf() < moment(end).subtract(num, unit).valueOf()) {
                value[1] = moment(dateString).add(num, unit).format(monthFormat);
            }
            this.setState({ endOpen: true });
        } else {
            value[1] = dateString;
            if (disabledDate && begin && moment(dateString).valueOf() > moment(begin).add(num, unit).valueOf()) {
                value[0] = moment(dateString).subtract(num, unit).format(monthFormat);
            }
        }
        this.props.onChange(value, type);
    }

    handleOpenChange = (status, type) => {
        if (type === 'begin') {
            this.setState({ beginOpen: status });
        } else {
            this.setState({ endOpen: status });
        }
    }

    render() {
        const { beginOpen, endOpen } = this.state;
        const { value = [], style = {}, allowClear = true, separator } = this.props;
        const [begin, end] = value;
        return (
            <div style={{display: 'inline-block'}}>
                <MonthPicker
                    style={{...style, verticalAlign: 'middle' }}
                    open={beginOpen}
                    allowClear={allowClear}
                    value={begin ? moment(begin) : null}
                    disabledDate={this.disabledStartDate}
                    onOpenChange={status => this.handleOpenChange(status, 'begin')}
                    onChange={(date, dateString) => this.handleChange(date, dateString, 'begin')}
                />
                {separator ? <span style={{margin: '0 10px'}}>{separator}</span> : <span className="ant-divider" style={{margin: '0 10px'}} />}
                <MonthPicker
                    style={{...style, verticalAlign: 'middle' }}
                    open={endOpen}
                    allowClear={allowClear}
                    value={end ? moment(end) : null}
                    disabledDate={this.disabledEndDate}
                    onOpenChange={status => this.handleOpenChange(status, 'end')}
                    onChange={(date, dateString) => this.handleChange(date, dateString, 'end')}
                />
            </div>
        );
    }
}

export default DateRange;


// WEBPACK FOOTER //
// ./src/components/common/DateRange.new.js